import { render, staticRenderFns } from "./InspectorForm.vue?vue&type=template&id=87e0d866&"
import script from "./InspectorForm.vue?vue&type=script&lang=js&"
export * from "./InspectorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports